(() => {
  const notProvided = 'Niet ingevuld';

  const getValue = (form, selector) => {
    const field = form.querySelector(selector);
    return field ? field.value.trim() : '';
  };

  const setSummaryValue = (form, selector, value) => {
    const element = form.querySelector(selector);
    if (element) element.textContent = value || notProvided;
  };

  const buildInternalMessage = (form) => {
    const name = getValue(form, '[data-withdrawal-name]');
    const email = getValue(form, '[data-withdrawal-email]');
    const order = getValue(form, '[data-withdrawal-order]');
    const verification = getValue(form, '[data-withdrawal-verification]');

    return [
      'Nieuw herroepingsverzoek ontvangen.',
      'Controleer handmatig de orderstatus in Shopify en bij de fulfillment partner voordat er verdere actie wordt ondernomen.',
      'Er is geen automatische orderwijziging uitgevoerd.',
      '',
      `Naam: ${name}`,
      `E-mailadres: ${email}`,
      `Ordernummer of referentienummer: ${order}`,
      `Postcode of telefoonnummer ter verificatie: ${verification || notProvided}`,
      'Bevestiging klant: Ik wil gebruikmaken van mijn herroepingsrecht voor deze bestelling.',
      'Tag: herroepingsverzoek',
    ].join('\n');
  };

  document.querySelectorAll('#WithdrawalRequestForm').forEach((form) => {
    const step = form.querySelector('[data-withdrawal-step]');
    const summary = form.querySelector('[data-withdrawal-summary]');
    const reviewButton = form.querySelector('[data-withdrawal-review]');
    const editButton = form.querySelector('[data-withdrawal-edit]');
    const finalButton = form.querySelector('[data-withdrawal-final]');
    const bodyField = form.querySelector('[data-withdrawal-body]');
    const orderField = form.querySelector('[data-withdrawal-order]');

    if (orderField) {
      const order = new URLSearchParams(window.location.search).get('order');
      if (order && !orderField.value.trim()) orderField.value = order;
    }

    const updateSummary = () => {
      setSummaryValue(form, '[data-summary-name]', getValue(form, '[data-withdrawal-name]'));
      setSummaryValue(form, '[data-summary-email]', getValue(form, '[data-withdrawal-email]'));
      setSummaryValue(form, '[data-summary-order]', getValue(form, '[data-withdrawal-order]'));
      setSummaryValue(form, '[data-summary-verification]', getValue(form, '[data-withdrawal-verification]'));
      if (bodyField) bodyField.value = buildInternalMessage(form);
    };

    reviewButton?.addEventListener('click', () => {
      if (!form.reportValidity()) return;
      updateSummary();
      if (step) step.hidden = true;
      if (summary) summary.hidden = false;
      summary?.scrollIntoView({ block: 'start', behavior: 'smooth' });
      finalButton?.focus();
    });

    editButton?.addEventListener('click', () => {
      if (summary) summary.hidden = true;
      if (step) step.hidden = false;
      step?.scrollIntoView({ block: 'start', behavior: 'smooth' });
      form.querySelector('[data-withdrawal-name]')?.focus();
    });

    form.addEventListener('submit', (event) => {
      if (summary?.hidden) {
        event.preventDefault();
        reviewButton?.click();
        return;
      }

      updateSummary();
    });
  });
})();
